document.addEventListener("DOMContentLoaded", () => {
  const itemsContainer = document.querySelector(
    "[data-gh-sample-items]"
  );

  const countElement = document.querySelector(
    "[data-gh-sample-count]"
  );

  const totalElement = document.querySelector(
    "[data-gh-sample-total]"
  );

  const checkoutButton = document.querySelector(
    "[data-gh-sample-checkout]"
  );

  if (
    !itemsContainer ||
    !countElement ||
    !totalElement ||
    !checkoutButton
  ) {
    return;
  }

  const selectedSamples = new Map();

  function findCard(id) {
    return (
      document.getElementById(`gh-v4-card-${id}`) ||
      document.getElementById(`gh-v4-frame-card-${id}`) ||
      document.getElementById(`gh-v4-size-card-${id}`)
    );
  }

function getCurrency() {
  return (
    itemsContainer
      .closest(".gh-v4-configurator")
      ?.dataset.currency || "EUR"
  );
}

function formatPrice(price, currency = getCurrency()) {
  return new Intl.NumberFormat(
    currency === "CHF" ? "de-CH" : "de-DE",
    {
      style: "currency",
      currency: currency,
      currencyDisplay:
        currency === "CHF" ? "code" : "symbol"
    }
  ).format(price);
}

  function updateSummary() {
    itemsContainer.innerHTML = "";

    if (selectedSamples.size === 0) {
      const emptyMessage = document.createElement("p");

      emptyMessage.className =
        "gh-material-summary__empty";

      const language =
  itemsContainer
    .closest(".gh-v4-configurator")
    ?.dataset.language || "de";

emptyMessage.textContent =
  language === "en"
    ? "No material samples selected yet."
    : "Noch keine Materialmuster ausgewählt.";

      itemsContainer.appendChild(emptyMessage);
    }

    let total = 0;

    const currency = getCurrency();

selectedSamples.forEach((sample) => {
  const currentPrice =
    currency === "CHF"
      ? sample.priceChf
      : sample.priceEur;

  total += currentPrice;

      const item = document.createElement("div");
      item.className = "gh-material-summary__item";

      const image = document.createElement("img");
      image.src = sample.image || "";
      image.alt = sample.name;

      const details = document.createElement("div");
      details.className =
        "gh-material-summary__details";

const name = document.createElement("strong");
name.className = "gh-v4-summary__name";
name.textContent = sample.name;

const price = document.createElement("small");
price.className = "gh-v4-summary__price";
price.textContent = formatPrice(currentPrice, currency);

      details.appendChild(name);
      details.appendChild(price);

      const removeButton = document.createElement("button");

      removeButton.type = "button";
      removeButton.className =
        "gh-material-summary__remove";

      removeButton.dataset.removeId = sample.id;
      removeButton.setAttribute(
        "aria-label",
        `${sample.name} entfernen`
      );

      removeButton.innerHTML = "&minus;";

      item.appendChild(image);
      item.appendChild(details);
      item.appendChild(removeButton);

      itemsContainer.appendChild(item);
    });

    countElement.textContent = selectedSamples.size;
    totalElement.textContent = formatPrice(total, currency);
    checkoutButton.disabled = selectedSamples.size === 0;
  }

  document.addEventListener("click", (event) => {
    const selectionButton = event.target.closest(
      ".gh-v4-modal__select[data-id]"
    );

    if (selectionButton) {
      const sample = {
        id: selectionButton.dataset.id,
        name:
          selectionButton.dataset.name ||
          selectionButton.dataset.materialName ||
          selectionButton.dataset.sizeName ||
          "Materialmuster",
        image: selectionButton.dataset.image || "",
        price: Number(
  selectionButton.dataset.price || 0
),
priceEur: Number(
  selectionButton.dataset.priceEur || 0
),
priceChf: Number(
  selectionButton.dataset.priceChf || 0
),
variantId: Number(
  selectionButton.dataset.variantId || 0
)
      };

      if (!sample.id) {
        return;
      }

      const card = findCard(sample.id);

      if (selectedSamples.has(sample.id)) {
        selectedSamples.delete(sample.id);

        if (card) {
          card.classList.remove("is-selected");
        }
      } else {
        selectedSamples.set(sample.id, sample);

        if (card) {
          card.classList.add("is-selected");
        }
      }

      updateSummary();
      return;
    }

    const removeButton = event.target.closest(
      "[data-remove-id]"
    );

    if (!removeButton) {
      return;
    }

    const id = removeButton.dataset.removeId;
    const card = findCard(id);

    selectedSamples.delete(id);

    if (card) {
      card.classList.remove("is-selected");
    }

    updateSummary();
  });

checkoutButton.addEventListener("click", async () => {
  if (selectedSamples.size === 0) {
    return;
  }

  const samples = Array.from(selectedSamples.values());

  const missingVariant = samples.find(
    (sample) => !sample.variantId
  );

  if (missingVariant) {
    alert(
      `Für „${missingVariant.name}“ ist noch kein Shopify-Musterprodukt hinterlegt.`
    );
    return;
  }

  const originalButtonText = checkoutButton.textContent;

  checkoutButton.disabled = true;
  checkoutButton.textContent = "Wird hinzugefügt …";

  const cartItems = samples.map((sample) => ({
    id: sample.variantId,
    quantity: 1,
    properties: {
      Materialmuster: sample.name
    }
  }));

  try {
    const response = await fetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: cartItems
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        "Die Materialmuster konnten nicht hinzugefügt werden."
      );
    }

    window.location.href =
      `${window.Shopify.routes.root}cart`;
  } catch (error) {
    console.error(error);

    alert(
      "Die Materialmuster konnten leider nicht in den Warenkorb gelegt werden."
    );

    checkoutButton.disabled = false;
    checkoutButton.textContent = originalButtonText;
  }
});

const currencyButtons = document.querySelectorAll(
  ".gh-v4-currency-switch__button"
);

currencyButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const configurator = button.closest(
      ".gh-v4-configurator"
    );

    if (!configurator) return;

    const currency =
      button.dataset.currencyButton || "EUR";

    const countryCode =
      currency === "CHF" ? "CH" : "AT";

    const form = document.createElement("form");

    form.method = "POST";
    form.action = "/localization";
    form.style.display = "none";

    form.innerHTML = `
      <input type="hidden" name="_method" value="PUT">
      <input type="hidden" name="country_code" value="${countryCode}">
      <input type="hidden" name="return_to" value="${window.location.pathname}${window.location.search}">
    `;

    document.body.appendChild(form);
    form.submit();
  });
});

updateSummary();
});